import React from 'react'
import { useNavigate } from 'react-router-dom'
import storePersist from '../../redux/storePersist'
import { tenantDetails } from '../../request/request'

const AccountSettings = () => {
    const navigate = useNavigate()

    const handleLogout = () => {
        localStorage.removeItem('access-token')
        localStorage.removeItem('accessTokenMetadata')
        localStorage.removeItem('guestTokenMetadata')
        localStorage.removeItem('userProfile')
       
        const specificChannel = storePersist?.get("channels")?.current.find(
            (element:any) => element.SalesChannelName === "PCP"
        );
        tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
        tenantDetails.StoreId = specificChannel?.StoreId;
        tenantDetails.SalesChannelId = specificChannel?.Id;

        storePersist.set("application", "guest")
        // navigate('/dsa/auth/login')
        window.location.href = "/"
    }

    const menuItems = [
        { name: "Account", path: "/trainer/profile" },
        // { name: "Subscriptions", path: "/trainer/dbas" },
        // { name: "Purchase Programs", path: "/trainer/purchase-dba-types" },
        { name: "Address", path: "/trainer/address" },
        { name: "HelpCenter", path: "/trainer/helpcenter" },
        { name: "Logout", path: "", onClick: handleLogout },
    ];

    return (
        <div className="w-1/4 mt-20 flex flex-col items-center">
            {menuItems.map((item, index) => (
                <li
                    key={index}
                    onClick={() => item.path ? navigate(item.path) : item.onClick?.()}
                    className="flex items-center justify-start px-10 mx-10 py-3 w-full cursor-pointer"
                >
                    <svg fill="#FFB934" className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
                        <path d="M22,11V7.83L12,2.06,2,7.83V11H4v8H2v2H22V19H20V11ZM4,9l8-4.62L20,9H4ZM6,19V11H8v8Zm4,0V11h4v8Zm8,0H16V11h2Z" />
                    </svg>
                    <span className="ml-2 text-xs uppercase break-words whitespace-normal hover:text-[#FFB934]">
                        {item.name}
                    </span>
                </li>
            ))}
        </div>
    )
}

export default AccountSettings
